export default __webpack_public_path__ + "static/media/ls3_g02.a3c80af3.png";